/**
 * @generated SignedSource<<fffa2df07787dcff54de7df2a01841ca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AddAsanaProjectStreamInput = {
  clientMutationId?: string | null;
  id: string;
  includeAiGenerated: boolean;
  name: string;
  projectType: string;
  streamId: string;
};
export type AsanaStreamSettingsAddProjectStreamMutation$variables = {
  input: AddAsanaProjectStreamInput;
};
export type AsanaStreamSettingsAddProjectStreamMutation$data = {
  readonly addAsanaProjectStream: {
    readonly asyncResultId: any | null;
    readonly noteStream: {
      readonly asanaStream: {
        readonly asanaProject: {
          readonly externalId: string | null;
          readonly id: string;
          readonly name: string;
          readonly type: string | null;
          readonly workspaceExternalId: string | null;
        };
        readonly createdBy: {
          readonly fullName: string;
        };
      } | null;
      readonly id: string;
    } | null;
  } | null;
};
export type AsanaStreamSettingsAddProjectStreamMutation = {
  response: AsanaStreamSettingsAddProjectStreamMutation$data;
  variables: AsanaStreamSettingsAddProjectStreamMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "asyncResultId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "AsanaProjectNode",
  "kind": "LinkedField",
  "name": "asanaProject",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "workspaceExternalId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AsanaStreamSettingsAddProjectStreamMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AddAsanaProjectStreamPayload",
        "kind": "LinkedField",
        "name": "addAsanaProjectStream",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStream",
            "kind": "LinkedField",
            "name": "noteStream",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AsanaStreamNode",
                "kind": "LinkedField",
                "name": "asanaStream",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AsanaStreamSettingsAddProjectStreamMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AddAsanaProjectStreamPayload",
        "kind": "LinkedField",
        "name": "addAsanaProjectStream",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStream",
            "kind": "LinkedField",
            "name": "noteStream",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AsanaStreamNode",
                "kind": "LinkedField",
                "name": "asanaStream",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "43e8b2362ce5427de48aa46501e088fc",
    "id": null,
    "metadata": {},
    "name": "AsanaStreamSettingsAddProjectStreamMutation",
    "operationKind": "mutation",
    "text": "mutation AsanaStreamSettingsAddProjectStreamMutation(\n  $input: AddAsanaProjectStreamInput!\n) {\n  addAsanaProjectStream(input: $input) {\n    asyncResultId\n    noteStream {\n      id\n      asanaStream {\n        asanaProject {\n          id\n          name\n          type\n          externalId\n          workspaceExternalId\n        }\n        createdBy {\n          fullName\n          id\n        }\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c4303e1bfe45f90783fdd07b9c7911c7";

export default node;
